<template>
  <div class="step-numbers">
    <span v-for="(step, i) in steps" v-bind:key="step">
      <a href="#" class="button button-green" @click="(e) => selectPage(e,step)"  :class="step !== current?'button-stroke' : ''">{{ step }}</a>
      <span class="horizontal-stroke" v-if="i !== steps - 1"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: "StepNumbers",
  data() {
   return{
   }
  },
  methods:{
    selectPage(e, step){
      e.preventDefault();
      this.$emit("changePage", step);
    }
  },
  props: ["steps", "current"]
}
</script>

<style scoped>
.step-numbers{
  display: flex;
  align-items: center;
}
.step-numbers .button-green {
  background-color: #e3fc03;
  margin: 0;
  width: 50px;
  height: 50px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 1px 0 0;
}
.step-numbers .button-green:hover, .step-numbers .button-green:focus {
  color: #0e1416;
}
.step-numbers .button-stroke{
  background: rgba(0,0,0,0);
  border: 1px solid #C1C8CE;
}
.step-numbers span{
  display: flex;
  align-items: center;
}
.step-numbers .horizontal-stroke{
  width: 30px;
  height: 1px;
  background-color: #c1c8ce;
}

@media (max-width: 769px){
  .step-numbers .button{
    width: 35px;
    height: 35px;
  }
}
</style>
